<template>
  <div class="LKMunMehCardList">
    <template v-for="item in list">
      <LKMunMehCard
        :key="item.id"
        :data="item"
        :get-mun-meh="getMunMeh"
        class="LKMunMehCardList__item"
        v-on="$listeners"
      />
    </template>

    <div class="LKMunMehCardList__button-container">
      <LKProgressCircular
        v-if="loading"
        :size="50"
      />

      <v-btn
        v-else-if="canGetData"
        v-observe-visibility="observeVisibility"
        :color="color"
        dense
        depressed
        dark
        @click="onGetNextPage"
        v-text="'Загрузить еще'"
      />
    </div>
  </div>
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility'
import variables from '@/assets/scss/exports.scss'

import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKMunMehCard from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCard.vue'

export default {
  name: 'LKMunMehCardList',
  components: { LKMunMehCard, LKProgressCircular },
  directives: {
    ObserveVisibility,
  },
  props: {
    loading: Boolean,
    list: {
      type: Array,
      default: () => [],
    },
    getMunMeh: {
      type: Function,
      reuired: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    color: variables['webflow-color-blue'],
  }),
  computed: {
    canGetData() {
      const { count, per_page, page } = this.pagination
      return count > page * per_page
    },
    observeVisibility() {
      return {
        callback: this.onVisibilityChange,
        throttle: 300,
        throttleOptions: {
          leading: 'visible',
        },
      }
    },
  },
  methods: {
    onGetNextPage() {
      this.$emit('change:next-page')
    },
    onVisibilityChange(isVisible) {
      if (!isVisible) return
      if (this.loading) return
      this.onGetNextPage()
    },
  },
}
</script>

<style lang="scss">
.LKMunMehCardList {
  &__item {
    margin-bottom: 20px;
  }

  &__button-container {
    display: flex;
    justify-content: center;
  }
}
</style>
